module.exports = __webpack_public_path__ + "media/site_templates/www.airconditionerrepair.net.au/images/our_services_1-6e1e3dd0bec9ace3ff57b55bc1bed336.jpg";